import { getAppliedDealerSettings } from '@atc/wallet-payment-fns';
async function getSelectedCriteria() {
  let dealerSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let payments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let listingPrice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let interestRates = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const {
    interactions = {},
    tradeIn = {}
  } = payments;
  const {
    value: tradeInValue = 0,
    amountOwed = 0
  } = tradeIn;
  const {
    creditType,
    defaultLeaseDownPayment,
    downPayment,
    downPaymentPercent,
    interestRate,
    leaseMileageOptions,
    leaseTermOptions,
    localLeaseTerm,
    localLeaseMileageRange,
    selectedLoanTerm
  } = getAppliedDealerSettings({
    dealerSettings,
    walletInteractions: interactions,
    price: listingPrice,
    payments,
    nationalRates: interestRates
  });
  return {
    selectedCriteria: {
      selectedLoanTerm,
      selectedCreditType: creditType,
      leaseDownPayment: defaultLeaseDownPayment,
      financeDownPayment: downPayment,
      financeDownPaymentPercentage: downPaymentPercent,
      interestRate,
      selectedLeaseTerm: localLeaseTerm,
      selectedLeaseMileage: localLeaseMileageRange,
      leaseMileageOptions,
      leaseTermOptions,
      tradeInValue: tradeInValue === null ? 0 : tradeInValue,
      amountOwed: amountOwed === null ? 0 : amountOwed
    }
  };
}
export { getSelectedCriteria as default };
